export default __webpack_public_path__ + "static/padlock-ba26d4ade25dbca3a097270f86e28a34.png";